import {
    PROGRESSTEAMPLAN_FETCHING,
    PROGRESSTEAMPLAN_FAILED,
    PROGRESSTEAMPLAN_SUCCESS,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case PROGRESSTEAMPLAN_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case PROGRESSTEAMPLAN_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case PROGRESSTEAMPLAN_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  